module.exports = __webpack_public_path__ + "img/icon_lvjing_shuiguang_hover@2x.bd250703.png";